import { RiFolderCloudLine } from "@onemind-services-llc/react-icons-ng/ri";
import { AiOutlineSolution } from "@onemind-services-llc/react-icons-ng/ai";
import { MdOutlineIntegrationInstructions } from "@onemind-services-llc/react-icons-ng/md";

export const ONEMIND_NDT_CONSTANTS = {
  title: "Key Offerings of OneMind Services Network Digital Twin Cloud",
  list: [
    {
      icon: RiFolderCloudLine,
      title: "Network-Based POCs",
      content:
        "Validate new technologies and solutions in a virtual replica of your network before full-scale implementation.",
    },
    {
      icon: AiOutlineSolution,
      title: "Virtual Labs",
      content:
        "Create and manage virtual lab environments for training, development, and testing purposes.",
    },
    {
      icon: MdOutlineIntegrationInstructions,
      title: "Network Automation",
      content:
        "Implement and test automation strategies to streamline network operations and management.",
    },
  ],
  conclusion:
    "By leveraging OneMind Services' Network Digital Twin Cloud, organizations can accelerate innovation, enhance network reliability, and make informed decisions with confidence.",
};
